var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mail-list" }, [
    _c(
      "div",
      {
        staticClass: "mail-list-actions-bar",
        class: {
          "with-filters": !_vm.isGridMode && _vm.selectedThreadIds.length === 0,
        },
      },
      [
        _c(
          "div",
          { staticClass: "mail-list-select" },
          [
            _c("a-checkbox", {
              staticClass: "bulk-select-checkbox",
              attrs: {
                indeterminate: _vm.indeterminate,
                checked: _vm.checkAll,
              },
              on: { change: _vm.onCheckAllChange },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mail-list-search" }, [
          _c("div", { staticClass: "search-input-container" }, [
            _c("i", { staticClass: "material-icons search-icon" }, [
              _vm._v("search"),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchText,
                  expression: "searchText",
                },
              ],
              staticClass: "search-input",
              attrs: { type: "text", placeholder: _vm.$t("mail.searchEmail") },
              domProps: { value: _vm.searchText },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchText = $event.target.value
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        !_vm.isGridMode && _vm.selectedThreadIds.length === 0
          ? _c(
              "div",
              { staticClass: "inline-filter-tabs" },
              [
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("chatWindow.all") } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "inline-filter-tab",
                        class: { active: _vm.activeFilter === "all" },
                        on: {
                          click: function ($event) {
                            return _vm.setFilter("all")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("mail"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "filter-count" }, [
                          _vm._v(_vm._s(_vm.count.all)),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.mailType === "self" && _vm.folder !== "sent"
                  ? _c(
                      "a-tooltip",
                      { attrs: { title: _vm.$t("mail.unread") } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "inline-filter-tab",
                            class: { active: _vm.activeFilter === "unread" },
                            on: {
                              click: function ($event) {
                                return _vm.setFilter("unread")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("mark_email_unread"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "filter-count" }, [
                              _vm._v(_vm._s(_vm.count.unread)),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.mailType === "self" && _vm.folder !== "sent"
                  ? _c(
                      "a-tooltip",
                      { attrs: { title: _vm.$t("mail.unreply") } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "inline-filter-tab",
                            class: {
                              active: _vm.activeFilter === "unanswered",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.setFilter("unanswered")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("question_answer"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "filter-count" }, [
                              _vm._v(_vm._s(_vm.count.unanswered)),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "mail-list-tools" }, [
          _c(
            "button",
            {
              staticClass: "refresh-button",
              class: { rotating: _vm.loading },
              attrs: { disabled: _vm.loading },
              on: { click: _vm.refreshList },
            },
            [_c("i", { staticClass: "material-icons" }, [_vm._v("refresh")])]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.isGridMode
      ? _c("div", { staticClass: "mail-list-filters" }, [
          _vm.selectedThreadIds.length === 0
            ? _c(
                "div",
                { staticClass: "filter-tabs" },
                [
                  _c(
                    "a-tooltip",
                    { attrs: { title: _vm.$t("chatWindow.all") } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "filter-tab",
                          class: { active: _vm.activeFilter === "all" },
                          on: {
                            click: function ($event) {
                              return _vm.setFilter("all")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("mail"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "filter-label" }, [
                            _vm._v(_vm._s(_vm.$t("chatWindow.all"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "filter-count" }, [
                            _vm._v(_vm._s(_vm.count.all)),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.mailType === "self" && _vm.folder !== "sent"
                    ? _c(
                        "a-tooltip",
                        { attrs: { title: _vm.$t("mail.unread") } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "filter-tab",
                              class: { active: _vm.activeFilter === "unread" },
                              on: {
                                click: function ($event) {
                                  return _vm.setFilter("unread")
                                },
                              },
                            },
                            [
                              _c(
                                "i",
                                {
                                  staticClass: "material-icons",
                                  staticStyle: { "margin-left": "10px" },
                                },
                                [_vm._v("mark_email_unread")]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "filter-label" }, [
                                _vm._v(_vm._s(_vm.$t("mail.unread"))),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "filter-count" }, [
                                _vm._v(_vm._s(_vm.count.unread)),
                              ]),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mailType === "self" && _vm.folder !== "sent"
                    ? _c(
                        "a-tooltip",
                        { attrs: { title: _vm.$t("mail.unreply") } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "filter-tab",
                              class: {
                                active: _vm.activeFilter === "unanswered",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setFilter("unanswered")
                                },
                              },
                            },
                            [
                              _c(
                                "i",
                                {
                                  staticClass: "material-icons",
                                  staticStyle: { "margin-left": "10px" },
                                },
                                [_vm._v("question_answer")]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "filter-label" }, [
                                _vm._v(_vm._s(_vm.$t("mail.unreply"))),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "filter-count" }, [
                                _vm._v(_vm._s(_vm.count.unanswered)),
                              ]),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedThreadIds.length > 0
            ? _c("div", { staticClass: "bulk-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "bulk-action-button delete-button",
                    on: { click: _vm.handleDelete },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("delete"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("ticket.delete")))]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "bulk-action-button read-button",
                    on: { click: _vm.handleMarkRead },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("mark_email_read"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("form.read")))]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "selected-count" }, [
                  _vm._v(
                    _vm._s(_vm.selectedThreadIds.length) + " mail seçildi"
                  ),
                ]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isGridMode && _vm.selectedThreadIds.length > 0
      ? _c("div", { staticClass: "mail-list-filters" }, [
          _c("div", { staticClass: "bulk-actions" }, [
            _c(
              "button",
              {
                staticClass: "bulk-action-button delete-button",
                on: { click: _vm.handleDelete },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("delete")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("ticket.delete")))]),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "bulk-action-button read-button",
                on: { click: _vm.handleMarkRead },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("mark_email_read"),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("form.read")))]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "selected-count" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("mail.selectedMail", {
                    count: _vm.selectedThreadIds.length,
                  })
                )
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mail-items-container" },
      [
        _vm.loading
          ? _c("div", { staticClass: "mail-loading-indicator" }, [
              _c("div", { staticClass: "mail-loading-bar" }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a-checkbox-group",
          {
            staticClass: "mail-items-list",
            model: {
              value: _vm.selectedThreadIds,
              callback: function ($$v) {
                _vm.selectedThreadIds = $$v
              },
              expression: "selectedThreadIds",
            },
          },
          [
            _vm._l(_vm.threads, function (thread) {
              return _c(
                "div",
                {
                  key: thread._id,
                  staticClass: "mail-item",
                  class: {
                    unread: !thread.isRead,
                    active: _vm.selectedThreadId === thread._id,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.selectThread(thread)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "mail-item-checkbox" },
                    [
                      _c("a-checkbox", {
                        staticClass: "bulk-select-checkbox",
                        attrs: { value: thread._id },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "mail-item-content" }, [
                    _c("div", { staticClass: "mail-item-header" }, [
                      _c("div", { staticClass: "sender-name" }, [
                        _vm._v(_vm._s(_vm.getParticipants(thread))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mail-date" }, [
                        _vm._v(_vm._s(_vm.formatDate(thread.createdAt))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mail-item-subject" }, [
                      _c("span", { staticClass: "subject-text" }, [
                        _vm._v(_vm._s(thread.subject)),
                      ]),
                      _vm._v(" "),
                      thread.attachments && thread.attachments.length
                        ? _c("span", { staticClass: "attachment-icon" }, [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("attachment"),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mail-item-preview" }, [
                      _vm._v(_vm._s(_vm.getPreviewText(thread.content))),
                    ]),
                  ]),
                ]
              )
            }),
            _vm._v(" "),
            _vm.threads.length === 0
              ? _c("div", { staticClass: "no-mails-message" }, [
                  _c("div", { staticClass: "empty-icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("mail"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.$t("mail.noMailFound")))]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showLoadMoreButton
              ? _c("div", { staticClass: "load-more-container" }, [
                  _c(
                    "button",
                    {
                      staticClass: "load-more-button",
                      attrs: { disabled: _vm.loading },
                      on: { click: _vm.loadMoreMails },
                    },
                    [
                      _vm.loading
                        ? _c("i", { staticClass: "material-icons" }, [
                            _vm._v("sync"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.loading
                              ? _vm.$t("message.loading")
                              : _vm.$t("billing.more")
                          )
                        ),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }